import { render, staticRenderFns } from "./word.vue?vue&type=template&id=8f9bfa22"
import script from "./word.vue?vue&type=script&lang=js"
export * from "./word.vue?vue&type=script&lang=js"
import style0 from "./word.vue?vue&type=style&index=0&id=8f9bfa22&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports